import { render, staticRenderFns } from "./file-view-modal.vue?vue&type=template&id=67dd58aa"
import script from "./file-view-modal.vue?vue&type=script&lang=js"
export * from "./file-view-modal.vue?vue&type=script&lang=js"
import style0 from "./file-view-modal.vue?vue&type=style&index=0&id=67dd58aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports